import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/culinary";
const TITLE = "Culinary at Backland — Seasonal Dining & Sample Menus";
const DESC =
  "Culinary at Backland — Chef prepared meals taken care of for you so all you have to sit back and enjoy the flavor and the view.";
const OG_DESC =
  "Thoughtful, seasonal dining at Backland: Chef prepared meals taken care of for you so all you have to sit back and enjoy the flavor and the view.";
const OG_IMAGE =
  "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg";

export const Route = createFileRoute("/culinary")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: OG_DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Restaurant",
          name: "Backland — Culinary",
          servesCuisine: "Seasonal American",
          url: URL,
          description: DESC,
        }),
      },
    ],
  }),
  component: CulinaryRoute,
});

function CulinaryRoute() {
  return <StoryExperience initialCategorySlug="culinary" />;
}
